import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	users: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	user: { error: null, loading: false, data: null },
	editedUser: { error: null, loading: false, data: null },
	removedUser: { error: null, loading: false, data: null },
	createdUser: { error: null, loading: false, data: null },
	currentUser: { data: null, error: false, loading: false, fetched: false },
	userTypes: { error: null, loading: false, data: null },
	modals: { error: null, loading: false, data: null },
	currentBaseId: null,
	downloadCsv: { error: null, loading: false },
};

const { actions, reducer } = createSlice({
	name: 'users',
	initialState,
	reducers: {
		getUsers: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.users = {
				...state.users,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getUsersFailure: (state, { payload }) => {
			state.users = {
				...state.users,
				error: payload,
				loading: false,
			};
		},
		getUsersSuccess: (state, { payload }) => {
			state.users = {
				...state.users,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getCurrentUser: (state) => {
			state.currentUser = {
				...state.currentUser,
				error: null,
				loading: true,
			};
		},
		getCurrentUserFailure: (state, { payload }) => {
			state.currentUser = {
				...state.currentUser,
				error: payload,
				loading: false,
			};
		},
		getCurrentUserSuccess: (state, { payload }) => {
			state.currentUser.data = payload;
			state.currentUser.error = null;
			state.currentUser.loading = false;
			state.currentUser.fetched = true; //!
		},
		editCurrentUser: (state, { payload }) => {
			state.currentUser = {
				...state.currentUser,
				error: null,
				loading: true,
			};
		},
		editCurrentUserFailure: (state, { payload }) => {
			state.currentUser = {
				...state.currentUser,
				error: payload,
				loading: false,
			};
		},
		editCurrentUserSuccess: (state, { payload }) => {
			state.currentUser = {
				...state.currentUser,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getUserById: (state, { payload }) => {
			state.user = {
				...state.user,
				error: null,
				loading: true,
			};
		},
		getUserByIdFailure: (state, { payload }) => {
			state.user = {
				...state.user,
				error: payload,
				loading: false,
			};
		},
		getUserByIdSuccess: (state, { payload }) => {
			state.user = {
				...state.user,
				data: payload,
				error: null,
				loading: false,
			};
		},
		createUser: (state, { payload }) => {
			state.createdUser = {
				...state.createdUser,
				error: null,
				loading: true,
			};
		},
		createUserFailure: (state, { payload }) => {
			state.createdUser = {
				...state.createdUser,
				error: payload,
				loading: false,
			};
		},
		createUserSuccess: (state, { payload }) => {
			state.createdUser = {
				...state.createdUser,
				data: payload,
				error: null,
				loading: false,
			};
		},
		updateUser: (state, { payload }) => {
			state.editedUser = {
				...state.editedUser,
				error: null,
				loading: true,
			};
		},
		updateUserFailure: (state, { payload }) => {
			state.editedUser = {
				...state.editedUser,
				error: payload,
				loading: false,
			};
		},
		updateUserSuccess: (state, { payload }) => {
			state.editedUser = {
				...state.editedUser,
				data: payload,
				error: null,
				loading: false,
			};
		},
		removeUser: (state, { payload }) => {
			state.removedUser = {
				...state.removedUser,
				error: null,
				loading: true,
			};
		},
		removeUserFailure: (state, { payload }) => {
			state.removedUser = {
				...state.removedUser,
				error: payload,
				loading: false,
			};
		},
		removeUserSuccess: (state, { payload }) => {
			state.removedUser = {
				...state.removedUser,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getUserTypes: (state) => {
			state.userTypes = {
				...state.userTypes,
				error: null,
				loading: true,
			};
		},
		getUserTypesFailure: (state, { payload }) => {
			state.userTypes = {
				...state.userTypes,
				error: payload,
				loading: false,
			};
		},
		getUserTypesSuccess: (state, { payload }) => {
			state.userTypes = {
				...state.userTypes,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getModals: (state) => {
			state.modals = {
				...state.modals,
				error: null,
				loading: true,
			};
		},
		getModalsFailure: (state, { payload }) => {
			state.modals = {
				...state.modals,
				error: payload,
				loading: false,
			};
		},
		getModalsSuccess: (state, { payload }) => {
			state.modals = {
				...state.modals,
				data: payload,
				error: null,
				loading: false,
			};
		},
		setCurrentBaseId: (state, { payload }) => {},
		setCurrentBaseIdSuccess: (state, { payload }) => {
			state.currentBaseId = payload;
		},
		downloadCsv: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: null,
				loading: true,
			};
		},
		downloadCsvFailure: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: payload,
				loading: false,
			};
		},
		downloadCsvSuccess: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: null,
				loading: false,
			};
		},
	},
});

export const {
	getUsers,
	getUsersFailure,
	getUsersSuccess,
	getCurrentUser,
	getCurrentUserFailure,
	getCurrentUserSuccess,
	editCurrentUser,
	editCurrentUserFailure,
	editCurrentUserSuccess,
	getUserById,
	getUserByIdFailure,
	getUserByIdSuccess,
	createUser,
	createUserSuccess,
	createUserFailure,
	updateUser,
	updateUserSuccess,
	updateUserFailure,
	removeUser,
	removeUserSuccess,
	removeUserFailure,
	getUserTypes,
	getUserTypesFailure,
	getUserTypesSuccess,
	getModals,
	getModalsFailure,
	getModalsSuccess,
	setCurrentBaseId,
	setCurrentBaseIdSuccess,
	downloadCsv,
	downloadCsvFailure,
	downloadCsvSuccess,
} = actions;

export { default as usersSaga } from './sagas';

export default reducer;
